<template>
  <v-card class="py-2 mx-auto" min-width="100" :max-width="MAX_CONTENT_WIDTH">
    <h1 class="page-title">{{ pageHeader }}</h1>
    <v-divider></v-divider>
    <v-btn @click="createList" color="primary">New List</v-btn>
    <v-divider></v-divider>
    <div v-for="mediaList in mediaLists" :key="'mediaList-' + mediaList.id">
      <h2
        ><router-link
          :to="{
            name: 'media-list',
            params: {
              username: routeUser,
              listId: mediaList.id,
            },
          }"
          >{{ mediaList.title }}</router-link
        ></h2
      >
      <p>{{ mediaList.description }}</p>
      <ul>
        <li
          v-for="entry in mediaList.previewEntries"
          :key="'previewEntry-' + mediaList.id + entry.work.medium + entry.work.id"
          >{{ entry.work.title }}</li
        >
      </ul>
    </div>
  </v-card>
</template>

<script>
import { MAX_CONTENT_WIDTH } from "../util/constants";

export default {
  name: "user-media-lists",

  data: function () {
    return {
      MAX_CONTENT_WIDTH,

      userId: undefined,
      mediaLists: [],
    };
  },

  computed: {
    pageHeader() {
      return `${this.authenticatedUserIsRouteUser ? "My" : this.routeUser + "'s"} Lists`;
    },

    authenticatedUser() {
      return this.$store.state.username;
    },

    routeUser() {
      return this.$route.params.username;
    },

    authenticatedUserIsRouteUser() {
      return this.authenticatedUser && this.routeUser.toLowerCase() == this.authenticatedUser.toLowerCase();
    },
  },

  async mounted() {
    const response = await this.$axios.get("/profile", {
      params: {
        user: this.routeUser,
      },
    });
    this.userId = response.data.id;

    await this.getUsersMediaLists();
  },

  methods: {
    async getUsersMediaLists() {
      const response = await this.$axios.get(`/v1/lists`, {
        params: {
          owner: this.userId,
        },
      });
      const items = response.data.items;

      for (const mediaList of items) {
        const response = await this.$axios.get(`/v1/lists/${mediaList.id}/entries`, {
          params: {
            limit: 10,
          },
        });
        console.log(response);
        mediaList.previewEntries = response.data.items;
      }

      this.mediaLists = items;
    },

    async createList() {
      const response = await this.$axios.post(`/v1/lists`, {
        title: "New List",
        isRanked: false,
        isPrivate: true,
      });

      this.$router.push({
        name: "media-list",
        params: {
          username: this.routeUser,
          listId: response.data.id,
        },
      });
    },
  },
};
</script>
